import Swal from 'sweetalert2'

const StartLoading = ({ commit, state }) => {
	commit('ADD')
}

const FinishLoading = ({ commit, state }) => {
	commit('REM')
}

const ToggleThemeCommit = ({ commit }, payload) => {
	localStorage.setItem('theme', payload)

	commit('TOGGLE_THEME', payload)
}

const ToggleTheme = ({ commit, rootState, dispatch }, payload) => {
	return window.api
		.call('post', '/save-setting', {
			account_id: rootState.auth.account.id,
			theme: payload,
		})
		.then(async ({ data }) => {
			if (data.response) {
				await dispatch('ToggleThemeCommit', payload)
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Eita!',
					text: 'Houve um erro ao salvar o tema, contate o suporte.',
				})
			}
		})
}

const ToggleShowSidebar = ({ commit, state }, payload = null) => {
	const currentState = payload !== null ? !payload : state.showSidebar

	commit('TOGGLE_SHOW_SIDEBAR', !currentState)
	localStorage.setItem('showSidebar', !currentState ? 'true' : 'false')
}

const SetCarouselOrientationCommit = ({ commit }, payload) => {
	localStorage.setItem('carousel_orientation', payload)

	commit('UPDATE_CAROUSEL_ORIENTATION', payload)
}

const SetCarouselOrientation = ({ commit, rootState, dispatch }, payload) => {
	return window.api
		.call('post', '/save-setting', {
			account_id: rootState.auth.account.id,
			menu_grid_type: payload,
		})
		.then(async ({ data }) => {
			if (data.response) {
				await dispatch('SetCarouselOrientationCommit', payload)
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Eita!',
					text: 'Houve um erro ao salvar a orientação do menu carrosel, contate o suporte.',
				})
			}
		})
}

const SetIconsSizeCommit = ({ commit }, payload) => {
	localStorage.setItem('icon_size', payload)

	commit('UPDATE_ICON_SIZE', payload)
}

const SetIconsSize = ({ commit, rootState, dispatch }, payload) => {
	return window.api
		.call('post', '/save-setting', {
			account_id: rootState.auth.account.id,
			menu_icon_size: payload,
		})
		.then(async ({ data }) => {
			if (data.response) {
				await dispatch('SetIconsSizeCommit', payload)
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Eita!',
					text: 'Houve um erro ao salvar o tamanho do ícone, contate o suporte.',
				})
			}
		})
}

const SetMenuOrderCommit = ({ commit }, payload) => {
	localStorage.setItem('menu_order', JSON.stringify(payload))

	commit('UPDATE_MENU_ORDER', payload)
}

const SetMenuOrder = ({ commit, rootState, dispatch }, payload) => {
	return window.api
		.call('post', '/save-setting', {
			account_id: rootState.auth.account.id,
			menu_order: payload.menu_mapped,
		})
		.then(async ({ data }) => {
			if (data.response) {
				await dispatch('SetMenuOrderCommit', payload.custom_menu)
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Eita!',
					text: 'Houve um erro ao salvar a ordem do menu, contate o suporte.',
				})
			}
		})
}

const GetModulesAndModalities = (
	{ commit, dispatch, rootState },
	payload = {}
) => {
	if (!rootState.auth.requester_selected_id) {
		return
	}

	dispatch('StartLoading')

	return window.api
		.call('post', '/get-modules-and-modalities', {
			organization_id: rootState.auth.requester_selected_id,
			schedule_type: payload.schedule_type,
			check_unavailable: payload.check_unavailable,
			with_instructions: payload.with_instructions,
		})
		.then(({ data }) => {
			if (data.response) {
				commit('UPDATE_MODULES', data.modules)
				commit('UPDATE_MODALITIES', data.modalities)
				commit('UPDATE_DICOM_MODALITIES', data.dicom_modalities)
			}
		})
		.finally(() => {
			dispatch('FinishLoading')
		})
}

const GetModulesModalitiesAndSchedules = (
	{ commit, dispatch, rootState },
	payload = {}
) => {
	if (!rootState.auth.requester_selected_id) {
		return
	}

	dispatch('StartLoading')

	return window.api
		.call('post', '/get-modules-modalities-and-schedules', {
			organization_id: rootState.auth.requester_selected_id,
		})
		.then(({ data }) => {
			if (data.response) {
				commit('UPDATE_MODULES', data.modules)
				commit('UPDATE_MODALITIES', data.modalities)
				commit('UPDATE_SCHEDULES', data.schedules)
			}
		})
		.finally(() => {
			dispatch('FinishLoading')
		})
}

const SetLastModalityId = ({ commit, dispatch }, payload) => {
	commit('UPDATE_LAST_MODALITY_ID', payload)
}

const KeepConnected = ({ commit }, payload) => {
	const keep_connected = {
		active: payload.active,
		time: payload.time,
	}

	localStorage.setItem('keep_connected', JSON.stringify(keep_connected))
	commit('UPDATE_KEEP_CONNECTED', keep_connected)
}

const SetFavoriteRouteName = ({ commit, state }, payload) => {
	if (state.favoriteRouteName === payload) {
		localStorage.removeItem('favoriteRouteName')
		commit('UPDATE_FAVORITE_ROUTE_NAME', '')
		return
	}

	localStorage.setItem('favoriteRouteName', payload)
	commit('UPDATE_FAVORITE_ROUTE_NAME', payload)
}

const SetSelectedReceptionCounter = ({ commit }, payload) => {
	sessionStorage.setItem('selectedReceptionCounter', payload)
	commit('UPDATE_SELECTED_RECEPTION_COUNTER', payload)
}

const ToggleToolBar = ({ commit }, payload) => {
	commit('TOGGLE_TOOLBAR', payload)
}

const ToggleInfoBar = ({ commit }, payload) => {
	commit('TOGGLE_INFOBAR', payload)
}

const ToggleSubtitle = ({ commit }, payload) => {
	commit('TOGGLE_SUBTITLE', payload)
}

export {
	StartLoading,
	FinishLoading,
	GetModulesAndModalities,
	GetModulesModalitiesAndSchedules,
	ToggleTheme,
	ToggleThemeCommit,
	ToggleShowSidebar,
	SetIconsSize,
	SetIconsSizeCommit,
	SetCarouselOrientation,
	SetCarouselOrientationCommit,
	SetMenuOrder,
	SetMenuOrderCommit,
	SetLastModalityId,
	KeepConnected,
	SetFavoriteRouteName,
	SetSelectedReceptionCounter,
	ToggleToolBar,
	ToggleInfoBar,
	ToggleSubtitle,
}
